export default "__VITE_ASSET__12717307__"